/**
 * Shared header geometry for every sede landing (Verde Vercelli, Verde
 * Valsesia 2): one bar height, one round-button size, one CTA pill, one
 * wordmark size. Colours are NOT here — each site keeps its own palette and
 * adds its border/background/text classes next to these.
 */

/** Bar height at every width (the VV2 full-screen menu's top bar matches it). */
export const HEADER_BAR_H = 'h-16'

/** Round header button — the language button (文A + code) and the day/night toggle. Add a border colour. */
export const HEADER_CIRCLE =
  'relative inline-flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-full border'

/**
 * «Sopralluogo gratuito» pill. Add background, text colours and the site's own transition + hover.
 * «SOPRALLUOGO GRATUITO» is ≈ 226 px (Inter 600, 12 px, 0.12em, px-5); the min-width holds
 * every language at that size («FREE SITE VISIT» is ≈ 154 px), so switching IT ⇄ EN does not
 * reflow the header. Budgets: the mobile-menu row [CTA · language · theme] fits a 360 px
 * phone with `gap-2`; the EN desktop bar at `lg` uses ≈ 967 of 992 px. At 0.16em it overflowed.
 * Height `h-10`, the round buttons' 40 px (owner, 2026-09-24): the three controls on the bar
 * stand one height.
 */
export const HEADER_CTA =
  'inline-flex h-10 min-w-[228px] items-center justify-center whitespace-nowrap rounded-full px-5 text-xs font-semibold uppercase tracking-[0.12em]'

/** Brand wordmark next to (or instead of) the logo. Add the site's display font. */
export const HEADER_WORDMARK = 'whitespace-nowrap text-xl leading-none'

/** Desktop nav links. */
export const HEADER_NAV_TEXT = 'text-sm'
